<template>


  <nav class="navbar" role="navigation" aria-label="main navigation">
    <img src="../assets/favicon.png" class="is-hidden">
    <div class="navbar-brand">

      <a class="navbar-item" href="/" id="nb-logo">COMBINE</a>

      <a @click="toggleBurger" role="button" :class="{'navbar-burger' : true, 'is-active' : showBurger}" data-target="navbar" aria-label="menu" aria-expanded="false">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>

    </div>

    <div class="navbar-menu" id="navMenu" v-if="!user">
      <div class="navbar-end">
        <div class="navbar-item"><router-link to="prices" class="nb-itm">PRISER</router-link></div>
        <!--  <div class="navbar-item"><router-link to="about" class="nb-itm">UTFORSK TIMER</router-link></div> -->
        <div class="navbar-item"><router-link to="gyms" class="nb-itm">VÅRE SENTRE</router-link></div>

        <div class="navbar-item"><router-link to="sign-in"><div class="button" id="nb-login">LOGG INN</div></router-link></div>
        <div class="navbar-item"><router-link to="sign-up"><div class="button is-primary is-outlined" id="nb-blm">BLI MEDLEM</div></router-link></div>

      </div>
    </div>


    <div class="navbar-menu" v-if="user">
      <div class="navbar-brand">

        <div v-if="isAdmin" class="navbar-item"><router-link to="admin" class="nb-itm">Admin</router-link></div>
        <div v-if="isAdmin" class="navbar-item"><router-link to="studioadmin" class="nb-itm">StudioAdmin</router-link></div>

      </div>
      <div class="navbar-end">
        <div class="navbar-item"><router-link to="gyms" class="nb-itm">VÅRE SENTRE</router-link></div>
        <div class="navbar-item"><router-link to="explore" class="nb-itm">FINN GRUPPETIMER</router-link></div>
        <div class="navbar-item"><router-link to="user" class="nb-itm">MINE BOOKINGER</router-link></div>
        <div class="navbar-item"><router-link to="user" class="nb-itm">MIN SIDE</router-link></div>
        <div class="navbar-item"><a v-on:click="signOut" class="nb-itm">LOGG UT</a></div>
      </div>

    </div>

    <div v-if="!user" class="container mobile-nav" :class="{'is-hidden' : !showBurger}">
      <div class="navbar-item-burger" @click="showBurger = false"><router-link to="gyms" class="nb-itm-burger">VÅRE SENTRE</router-link></div>
      <div class="navbar-item-burger" @click="showBurger = false"><router-link to="sign-up" class="nb-itm-burger">BLI MEDLEM</router-link></div>
      <div class="navbar-item-burger" @click="showBurger = false"><router-link to="sign-in" class="nb-itm-burger">LOGG INN</router-link></div>
    </div>

    <div v-if="user" class="container mobile-nav" :class="{'is-hidden' : !showBurger}">
      <div class="navbar-item-burger" @click="showBurger = false"><router-link to="gyms" class="nb-itm-burger">VÅRE SENTRE</router-link></div>
      <div class="navbar-item-burger" @click="showBurger = false"><router-link to="explore" class="nb-itm-burger">FINN GRUPPETIMER</router-link></div>
      <div class="navbar-item-burger" @click="showBurger = false"><router-link to="user" class="nb-itm-burger">MINE BOOKINGER</router-link></div>
      <div class="navbar-item-burger" @click="showBurger = false"><router-link to="signOut" class="nb-itm-burger">LOGG UT</router-link></div>
    </div>

  </nav>


</template>

<script>

import Firebase from 'firebase';

export default {
  data() {
    return {
      activeNav: '',
      hasPaid: false,
      isAdmin: false,
      user: '',

      showBurger: false,
    }
  },
  computed: {
    /*user() {
    return this.$store.getters.getUser;
  },*/

},
created() {
  if(this.$store.getters.getUser != null) {
    var userId = Firebase.auth().currentUser.uid;
    Firebase.database().ref('users/'+userId+'/hasPaid').on('value', snapshot => {
      this.hasPaid = snapshot.val();
    });
  };
  if(this.$store.getters.getUser != null) {
    var userId = Firebase.auth().currentUser.uid;
    Firebase.database().ref('users/'+userId).on('value', snapshot => {
      var user = snapshot.val();
      this.user = user;
      if(user.admin) {this.isAdmin = true};
    });
  }
},
methods: {
  signOut: function() {
    Firebase.auth()
    .signOut()
    .then(() => {
      this.$router.replace('/');
    });
  },
  toggleBurger: function(){
    if(this.showBurger === false) {this.showBurger = true}
    else {this.showBurger = false}
  }
},
};


</script>

<style lang="scss">

@font-face {
  font-family: Futura;
  src: url("../assets/fonts/Futura-Bold-03.ttf") format("opentype");
}
@media screen and (max-width: 768px) {

  .navbar-burger {
    margin-top: 4px;
  }

  .mobile-nav{
    padding-top: 30px;
    padding-bottom: 20px;
    background-color: #F5F7F9;
    text-align: center;
    transition: height 0.8s;
  }

  nav.navbar{
    padding-left: 10px;
    padding-right: 10px;
    height: 60px;
    position: fixed;
    width: 100%;
    background-color: #F5F7F9;
    z-index:3;
    transition: 0.4s;
  }

  .nb-itm-burger {
    color: #18253E;
    font-family: 'Montserrat', sans-serif;
    font-size: 1.3rem;
  }

  .navbar-item-burger{
    padding-bottom: 20px;
  }

  #nb-logo {
    font-size: 1.6rem;
    font-family: 'Futura';
    font-weight: 800;
    letter-spacing: 0px;
    color: #3a3a3a;

  }

  iframe {
    box-shadow: 0;
  }



}

@media screen and (min-width: 768px) {

  nav.navbar{
    padding-left: 100px;
    padding-right: 100px;
    height: 65px;
    position: fixed;
    width: 100%;
    background-color: transparent;/*#F5F7F9;*/
    z-index:3;
    transition: 0.4s;
  }
  nav.scrolled{
    padding-left: 100px;
    padding-right: 100px;
    height: 65px;
    position: fixed;
    width: 100%;
    background-color: #F5F7F9;
    z-index:3;
    transition: 0.4s;
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.04);
  }

  #scroll{
    color:white;
    position: fixed;
    width: 100%;
    background-color: white;
    box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.04);
    z-index:3;
  }

  #itm-scroll {
    color: #3a3a3a;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
  }
  .nb-itm {
    color: #18253E;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
  }
  .nb-itm:hover {
    color: #00D2B2;
    transition: 0.5s;

  }
  .nb-itm-scrolled {
    color: #3a3a3a;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
  }
  .nb-itm-scrolled:hover {
    color: #00D2B2;
    transition: 0.5s;
  }

  #nb-login {
    color: #3a3a3a;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    border-width: 0px;
    background-color: transparent;
  }
  #nb-login:hover {
    color: #00D2B2;
    transition: 0.3s;

  }
  #nb-blm {
    color: white;
    border-radius: 0px;
    border-color: #00D2B2;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    background-color: #00D2B2;
  }
  #nb-blm:hover {
    background-color: #01B197;
    color: white;
    border-radius: 0px;
    border-color: #01B197;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);
    transition: all 0.5s
  }
  #logo-scroll {
    font-size: 40px;
    font-family: 'Futura';
    font-weight: 800;
    letter-spacing: 0px;
    color: #3a3a3a;

  }
  #nb-logo {
    font-size: 30px;
    font-family: 'Futura';
    font-weight: 800;
    letter-spacing: 0px;
    color: #3a3a3a;

  }
  #nb-logo:hover {
    background-color: transparent;
    color: grey;
  }

  iframe {
    box-shadow: 0;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue